import { useRef, useState } from 'react';
import { HttpService } from 'core/services/http';

/**
 * Upload or remove profile cover (header_image) via POST /auth/profile/update/
 */
export default function useProfileHeaderUpload({ profile, onDone, enqueueSnackbar }) {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const pickFile = () => inputRef.current?.click();

    const onFileChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file || !profile) return;
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append('header_image', file);
            fd.append('first_name', profile.first_name || '');
            fd.append('last_name', profile.last_name || '');
            await new HttpService().post('/auth/profile/update/', fd, true);
            enqueueSnackbar?.('Cover photo updated', { variant: 'success' });
            onDone?.();
        } catch (err) {
            enqueueSnackbar?.(err.message || 'Upload failed', { variant: 'error' });
        } finally {
            setUploading(false);
        }
    };

    const removeHeader = async () => {
        if (!window.confirm('Remove your cover photo?')) return;
        setUploading(true);
        try {
            const fd = new FormData();
            fd.append('remove_header_image', 'true');
            await new HttpService().post('/auth/profile/update/', fd, true);
            enqueueSnackbar?.('Cover photo removed', { variant: 'success' });
            onDone?.();
        } catch (err) {
            enqueueSnackbar?.(err.message || 'Could not remove cover', { variant: 'error' });
        } finally {
            setUploading(false);
        }
    };

    return { inputRef, uploading, pickFile, onFileChange, removeHeader };
}
